module.exports = __webpack_public_path__ + "static/media/S1_00034.696cfa34.jpg";